import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  FormGroup,
  Label,
} from "reactstrap";

class DeleteUserEmergencyContactModal extends React.Component {
  constructor(props) {
    super(props);
  }

  deleteUserEmergencyContact(e) {
    e.preventDefault();
    this.props.handleSubmit(this.props.userId, this.props.fullName);
  }

  render() {
    let { open, toggle, fullName } = this.props;
    return (
      <>
        <Modal isOpen={open} fade={false} toggle={toggle}>
          <ModalHeader toggle={toggle}>Xóa thông tin người thân</ModalHeader>
          <ModalBody>
            <div class="row">
              <div class="col-md-12">
                <Form onSubmit={(e) => this.deleteUserEmergencyContact(e)}>
                  <FormGroup>
                    <Label>
                      Bạn có chắc muốn xóa thông tin người thân {fullName}, hành
                      động này sẽ không thể hoàn tác!
                    </Label>
                  </FormGroup>
                  <Button className="mb-2 me-2 btn btn-danger" type="submit">
                    Đồng ý
                  </Button>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default DeleteUserEmergencyContactModal;
